import { render, staticRenderFns } from "./SupplierSearchBrowse.vue?vue&type=template&id=381ce40a"
import script from "./SupplierSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./SupplierSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports